import { ClientApplication, McVerificationStatusView } from '@numeo/types-core'
import { OrganizationData } from 'store/authSlice'

const toMcVerification = (result: McVerificationStatusView) => ({
    status: result.status,
    method: result.method,
    verifiedAt: result.verifiedAt,
    verifiedMcNumber: result.verifiedMcNumber,
    rejectionReason: result.rejectionReason,
})

export const syncMcVerificationToApplication = (application: ClientApplication | null, result: McVerificationStatusView): ClientApplication | null => {
    if (!application?.settings?.company) return application

    return {
        ...application,
        settings: {
            ...application.settings,
            company: {
                ...application.settings.company,
                mcVerification: toMcVerification(result),
            },
        },
    }
}

export const syncMcVerificationToOrganization = (
    organizationData: OrganizationData | null,
    applicationId: string | undefined,
    result: McVerificationStatusView,
    companyPatch?: { name?: string; mcNumber?: string; dotNumber?: string } | null
): OrganizationData | null => {
    if (!organizationData?.applications || !applicationId) return organizationData

    let changed = false
    const applications = organizationData.applications.map((app) => {
        if (app.id !== applicationId) return app

        changed = true
        return {
            ...app,
            company: {
                ...(app.company || {}),
                ...(companyPatch || {}),
                mcVerification: toMcVerification(result),
            },
        }
    })

    return changed ? { ...organizationData, applications } : organizationData
}
